/* ================= HOVER-INTENT DROPDOWN BEHAVIOR =================
   Adds deliberate open/close delays to navigation dropdowns so menus
   feel calm, precise, and high-end — no flicker, no accidental opens.

   Open delay:  150ms
   Close delay: 200ms

   Targets: top-level .nav-item.has-dropdown inside .header__inline-menu
   Mechanism: clicks the <summary> to toggle (preserves Dawn's internal state)
   Scope: desktop only (>=990px)
   Dependencies: none (vanilla JS, no jQuery)

   FIXED-POSITION DROPDOWN LOGIC:
   When a dropdown opens, the panel is switched to position:fixed and
   aligned beneath its <summary> trigger using getBoundingClientRect().
   This completely bypasses all ancestor overflow:hidden constraints
   from Dawn's deeply nested DOM. Includes viewport boundary clamping.
   ================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 200;
  var DESKTOP_MQ = "(min-width: 990px)";
  var EDGE_MARGIN = 12;

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  var dropdownParents = document.querySelectorAll(
    ".header__inline-menu > .list-menu > .nav-item.has-dropdown"
  );

  dropdownParents.forEach(function (item) {
    var openTimer = null;
    var closeTimer = null;

    var details = item.querySelector("details");
    if (!details) return;

    var summary = details.querySelector("summary");
    if (!summary) return;

    var panel = details.querySelector(":scope > .dropdown-panel, :scope > .header__submenu, :scope > .mega-menu__content, :scope > .dropdown-menu");
    if (!panel) return;

    var savedStyles = {};

    function openDropdown() {
      if (!details.hasAttribute("open")) {
        summary.click();
      }
    }

    function closeDropdown() {
      if (details.hasAttribute("open")) {
        summary.click();
      }
    }

    function positionPanel() {
      if (!isDesktop()) return;

      savedStyles = {
        position: panel.style.position || "",
        left: panel.style.left || "",
        top: panel.style.top || "",
        width: panel.style.width || "",
        maxWidth: panel.style.maxWidth || ""
      };

      var rect = summary.getBoundingClientRect();
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;

      panel.style.position = "fixed";
      panel.style.width = "";
      panel.style.maxWidth = "none";
      panel.classList.add("dropdown-panel--fixed");

      var desiredLeft = rect.left;
      var desiredTop = rect.bottom + 4;

      var panelWidth = panel.offsetWidth;
      var panelHeight = panel.offsetHeight;

      if (desiredLeft + panelWidth > vw - EDGE_MARGIN) {
        desiredLeft = vw - panelWidth - EDGE_MARGIN;
      }
      if (desiredLeft < EDGE_MARGIN) {
        desiredLeft = EDGE_MARGIN;
      }

      if (desiredTop + panelHeight > vh - EDGE_MARGIN) {
        var aboveTop = rect.top - panelHeight - 4;
        if (aboveTop >= EDGE_MARGIN) {
          desiredTop = aboveTop;
        } else {
          desiredTop = vh - panelHeight - EDGE_MARGIN;
        }
      }

      panel.style.left = desiredLeft + "px";
      panel.style.top = desiredTop + "px";
    }

    function resetPanel() {
      panel.style.position = savedStyles.position || "";
      panel.style.left = savedStyles.left || "";
      panel.style.top = savedStyles.top || "";
      panel.style.width = savedStyles.width || "";
      panel.style.maxWidth = savedStyles.maxWidth || "";
      panel.classList.remove("dropdown-panel--fixed");
      savedStyles = {};
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === "open") {
          if (details.hasAttribute("open")) {
            requestAnimationFrame(function () {
              positionPanel();
            });
          } else {
            resetPanel();
          }
        }
      });
    });
    observer.observe(details, { attributes: true });

    var rafId = null;
    function onScrollOrResize() {
      if (!details.hasAttribute("open")) return;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        positionPanel();
        rafId = null;
      });
    }
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize, { passive: true });

    item.addEventListener("mouseenter", function () {
      if (!isDesktop()) return;

      clearTimeout(closeTimer);
      closeTimer = null;

      if (!details.hasAttribute("open")) {
        openTimer = setTimeout(function () {
          openDropdown();
          openTimer = null;
        }, OPEN_DELAY);
      }
    });

    item.addEventListener("mouseleave", function () {
      if (!isDesktop()) return;

      clearTimeout(openTimer);
      openTimer = null;

      if (details.hasAttribute("open")) {
        closeTimer = setTimeout(function () {
          closeDropdown();
          closeTimer = null;
        }, CLOSE_DELAY);
      }
    });

    panel.addEventListener("mouseenter", function () {
      clearTimeout(closeTimer);
      closeTimer = null;
    });

    panel.addEventListener("mouseleave", function () {
      if (!isDesktop()) return;
      if (details.hasAttribute("open")) {
        closeTimer = setTimeout(function () {
          closeDropdown();
          closeTimer = null;
        }, CLOSE_DELAY);
      }
    });
  });
});
